module.exports = __webpack_public_path__ + "static/team-of-rivals-48924b15f1a1e0e7d6f025944c3fbe39.jpg";